import { render, staticRenderFns } from "./ArticlesCardView.vue?vue&type=template&id=3bc7a60d&scoped=true&"
import script from "./ArticlesCardView.vue?vue&type=script&lang=js&"
export * from "./ArticlesCardView.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesCardView.vue?vue&type=style&index=0&id=3bc7a60d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc7a60d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
